function toggleMenu()
{
    var menu = document.querySelector('#mobile-menu')
    menu.classList.toggle('!flex')
    menu.style.opacity = 0
    setInterval(function() {
       var opacity = parseFloat(menu.style.opacity);
       console.log(opacity);
       if (opacity < 1) {
          opacity += 0.02;
          menu.style.opacity = opacity;
       }
    }, 5);
}